import { render, staticRenderFns } from "./ItemAutocompleteInput.vue?vue&type=template&id=4aae6b6e&scoped=true"
import script from "./ItemAutocompleteInput.vue?vue&type=script&lang=ts"
export * from "./ItemAutocompleteInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae6b6e",
  null
  
)

export default component.exports